import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-status-dialog',
  templateUrl: './status-dialog.component.html',
  styleUrls: ['./status-dialog.component.css']
})
export class StatusDialogComponent {
  displayedColumns: string[] = [
    'ResignationDate',
    'IndicativeLWD',
    'LastWorkingDate',
    'ResignationType',
    'ResignationReason',
    'status',
    'ModifiedDate'
  ];

  constructor(
    public dialogRef: MatDialogRef<StatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //console.log('Dialog Data:', data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
